import React from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "../UIElements/Icon";

const Breadcrumb = ({ items = [] }) => {
  const navigate = useNavigate();

  const handleItemClick = (item) => {
    if (item.path && !item.disabled) {
      navigate(item.path);
    }
  };

  if (items.length === 0) return null;

  return (
    <nav className="mb-6 flex items-center space-x-2 text-sm text-gray-400">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <Icon name="ChevronRight" className="h-4 w-4 text-gray-500" />
          )}
          <button
            onClick={() => handleItemClick(item)}
            disabled={item.disabled}
            className={`transition-colors ${
              item.disabled
                ? "cursor-not-allowed text-gray-500"
                : "cursor-pointer hover:text-white"
            } ${item.active ? "font-medium text-white" : ""}`}
          >
            {item.icon && (
              <Icon name={item.icon} className="mr-1 inline h-4 w-4" />
            )}
            {item.label}
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
